import React, { useState } from 'react';

const Unsubscribe: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    setMessage(null);

    try {
      const res = await fetch('/api/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const json = await res.json().catch(() => ({} as any));

      if (!res.ok) {
        const fieldError = (json as any)?.field_errors?.email;
        throw new Error(fieldError || (json as any)?.message || `HTTP ${res.status}`);
      }

      setMessage(
        (json as any)?.message || 'If that email address is on our list, it has been unsubscribed.'
      );
      setEmail('');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Failed to submit unsubscribe request.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
        padding: '1rem',
      }}
    >
      <section
        style={{
          width: '100%',
          maxWidth: 520,
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 12,
          padding: '1.25rem',
        }}
      >
        <h1 style={{ margin: 0, fontSize: '1.25rem' }}>Unsubscribe</h1>
        <p style={{ marginTop: '0.5rem', color: '#475569', fontSize: '0.9375rem' }}>
          Enter your email address and we’ll remove it from newsletter emails.
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <label style={{ display: 'block', marginBottom: '0.375rem', fontWeight: 600, fontSize: '0.875rem' }}>
            Email address
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
            required
            style={{
              width: '100%',
              border: '1px solid #cbd5e1',
              borderRadius: 8,
              padding: '0.625rem 0.75rem',
              fontSize: '0.9375rem',
              marginBottom: '0.75rem',
            }}
          />

          <button
            type="submit"
            disabled={submitting}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: 'none',
              borderRadius: 8,
              padding: '0.625rem 0.875rem',
              fontWeight: 600,
              color: '#fff',
              background: submitting ? '#94a3b8' : '#0f766e',
              cursor: submitting ? 'not-allowed' : 'pointer',
            }}
          >
            {submitting ? 'Submitting…' : 'Unsubscribe'}
          </button>
        </form>

        {error && (
          <p style={{ marginTop: '0.75rem', color: '#b91c1c', fontSize: '0.875rem' }}>{error}</p>
        )}

        {message && (
          <p style={{ marginTop: '0.75rem', color: '#0f766e', fontSize: '0.875rem' }}>{message}</p>
        )}
      </section>
    </main>
  );
};

export default Unsubscribe;
